import axios from '../utils/axios';

export default function getUserAnalysis(adminId) {
    return axios.get(`/admin/${adminId}/user-analyis`)
}
